import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { FullClientDetailModel } from '../../Models/Models/Customer/FullClientDetailModel';
import { ValidationStatus } from '../../Core/Web/Validation/ValidationStatus';

declare var IS_RUNNING_IN_APP_POOL;

export class FullClientDetailClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(customerId: number): Promise<FullClientDetailModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/FullClientDetail/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId }

    return AjaxWrapper.get<FullClientDetailModel, any>(url, data);
  }
  public put(customerId: number, clientDetail: FullClientDetailModel): Promise<Array<ValidationStatus>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/FullClientDetail/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId, clientDetail: clientDetail }

    return AjaxWrapper.put<Array<ValidationStatus>, any>(url, data);
  }
}

